module.exports = __webpack_public_path__ + "img/blt-arrow01.0d551b21.svg";